module.exports = __webpack_public_path__ + "static/media/change-direction.938b4609.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/trailways/change-direction.svg
// module id = 237
// module chunks = 0